import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import "./styles.css";
import Breadcrumb from "../../../../common/Breadcrumb";
import { useStyles } from "../style";
import {
  RateAdminBreadcrumb,
  RateTypeDD,
  basicDetail,
  columns,
  editMode,
  rateAdjustment,
  rateExtraDaily,
  rateExtraMonthly,
  rateExtraWeekend,
  rateExtraWeekly,
  rateTest,
  statusDD,
  externalRateTest,
  ageOptions,
} from "../../RateAdminRates/CreateRateAdminRates/constant";
import {
  Box,
  Container,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import { generatePath, useNavigate } from "react-router-dom";
import { APP_URLS } from "../../../../utils/constant";
import EzControlledCalendarWithFloatingLabel from "../../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
import { getFormBaseValidationRule } from "../../../../utils/form/form-utils";
import { additionbaselor } from "../../../../utils/common";
import { formatDates, formatDatesHyphan } from "../../../../utils";
import EzDialog from "../../../../common/EzDialog";
import { useParams } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { hourslist } from "../../../Location/CreateLocation/constant";
const ViewInlineRateAdminRates = (props) => {
  const navigate = useNavigate();
  const {
    history,
    initCreateRateAdminRatesScreen,
    createRateAdminRates,
    createRateAdminRateAdjustment,
    editRateAdminRates,
    isLoading,
    isRateAdminRatesCreateSuccess,
    isRateAdminRateAdjSuccess,
    isRateAdminRatesCreateError,

    isRateAdminRateAdjListSuccess,
    isRateAdminRateAdjListError,
    isRateAdminRatesDetailSuccess,
    isRateAdminRatesDetailError,
    isRateAdminRatesEditSuccess,
    isRateAdminRatesEditError,
    isEdit,
    RateCodeDD,
    locationDD,
    vehicleCategoryDD,
    isView,
    formFieldValueMap,
    rateAdjustmentlist,
    formFieldValueMap2,
    RateOptionsDD,
    RateNetworkDD,
    shouldBlockNavigation,
    uploadImage,
    imageUploadResponse,
    isUploadImageSuccess,
    isUploadImageError,
    vehicleModelDD,
    isVehicleModelDDSuccess,
    isVehicleModelDDError,
    RateTest,
    TestRateAdminRates,
    ExternalNetworkDD,
    fetchExternalNetworkDD,
    ExternalRateTest,
    fetchExternalRateTest,
    clearExternalRateTest,
    isExternalRateTestSuccess,
    isExternalRateTestError,
    // New prop for inline view mode
    isInlineView = false,
    // Props for revenue preview
    fetchRevenuePreview,
    revenuePreviewData,
    isRevenuePreviewSuccess,
  } = props;
  console.log("check props of compoemnt", props);

  const classes = useStyles();

  const {
    control,
    formState: { errors, isDirty },
    watch,
    register,
    handleSubmit,
    reset,
    getValues,
  } = useForm({
    defaultValues: useMemo(() => {
      console.log("check value come or not", formFieldValueMap);
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });

  const {
    handleSubmit: handleSubmit2,
    control: control2,
    reset: resetForm2,
    formState: { errors: errors2, isDirty: isDirty2 },
  } = useForm({
    defaultValues: useMemo(() => {
      return formFieldValueMap2;
    }, [formFieldValueMap2]),
  });
  let formFieldValueMap3 = {
    endDate: "",
    endTime: "",
    rateId: "",
    startDate: "",
    startTime: "",
  };
  const {
    handleSubmit: handleSubmit3,
    control: control3,
    reset: resetForm3,
    formState: { errors: errors3, isDirty: isDirty3 },
  } = useForm({
    defaultValues: useMemo(() => {
      return formFieldValueMap3;
    }, [formFieldValueMap3]),
  });
  const [breakdown, setBreakdown] = useState(false);
  const dailybaseRate = watch("dailybaseRate");
  const dailylor1st = watch("dailylor1st");
  const dailylor2nd = watch("dailylor2nd");
  const dailylor3rd = watch("dailylor3rd");
  const dailylor4th = watch("dailylor4th");
  const dailylor5th = watch("dailylor5th");
  const dailylor6th = watch("dailylor6th");

  const weekendbaseRate = watch("weekendbaseRate");
  const weekendlor1st = watch("weekendlor1st");
  const weekendlor2nd = watch("weekendlor2nd");
  const weekendlor3rd = watch("weekendlor3rd");
  const weekendlor4th = watch("weekendlor4th");
  const weekendlor5th = watch("weekendlor5th");
  const weekendlor6th = watch("weekendlor6th");

  const weeklybaseRate = watch("weeklybaseRate");
  const weeklylor1st = watch("weeklylor1st");
  const weeklylor2nd = watch("weeklylor2nd");
  const weeklylor3rd = watch("weeklylor3rd");
  const weeklylor4th = watch("weeklylor4th");

  const [showDialog, setShowDialog] = useState(false);
  const [rateAdjustmentList, setRateAdjustmentList] = useState([]);
  const [isEditingInline, setIsEditingInline] = useState(false);

  useEffect(() => {
    if (!isEdit && !isView) {
      const defaultRateGroup = RateCodeDD?.find(item => item.isDefault === 1);
      if (defaultRateGroup) {
        reset((formValues) => ({ ...formValues, fkRateGroup: defaultRateGroup.id }));
      }

      const defaultNetwork = RateNetworkDD?.find(item => item.isDefault === 1);
      if (defaultNetwork) {
        reset((formValues) => ({ ...formValues, fkNetworkId: defaultNetwork.id }));
      }

      const actualRateOption = RateOptionsDD?.find(item => item.name === "Actual Rate");
      if (actualRateOption) {
        reset((formValues) => ({ ...formValues, rateOption: actualRateOption.id }));
      }

      reset((formValues) => ({ ...formValues, fkRateTypeId: 1 }));
    }
  }, [isEdit, isView, RateCodeDD, RateNetworkDD, RateOptionsDD, reset]);

    useEffect(() => {
      if (!isRateAdminRatesCreateSuccess && !isRateAdminRatesEditSuccess && shouldBlockNavigation) {
        shouldBlockNavigation(isDirty);
      }
    }, [isDirty, shouldBlockNavigation, isRateAdminRatesCreateSuccess, isRateAdminRatesEditSuccess]);

  const onDialogHide = () => {
    setShowDialog(false);
  };
  const showRateAdjustment = () => {
    setShowDialog(true);
  };

  const [showTestDialog, setShowTestDialog] = useState(false);
  const onDialogTestHide = () => {
    setShowTestDialog(false);
  };
  const showRateTest = () => {
    setShowTestDialog(true);
  };

  // External Rate Test Modal
  const [showExternalTestDialog, setShowExternalTestDialog] = useState(false);
  const [externalRateBreakdown, setExternalRateBreakdown] = useState(false);
  
  // Get tomorrow's date and day after tomorrow for default values
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const dayAfterTomorrow = new Date(today);
  dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
  
  let formFieldValueMapExternal = {
    externalNetwork: "",
    startDate: tomorrow,
    startTime: "10:00am",
    endDate: dayAfterTomorrow,
    endTime: "10:00am",
    age: "25",
  };

  const {
    handleSubmit: handleSubmit4,
    control: control4,
    reset: resetForm4,
    watch: watch4,
    formState: { errors: errors4 },
  } = useForm({
    defaultValues: useMemo(() => {
      return formFieldValueMapExternal;
    }, []),
  });

  const selectedExternalNetwork = watch4("externalNetwork");

  const onExternalDialogHide = () => {
    setShowExternalTestDialog(false);
    setExternalRateBreakdown(false);
    resetForm4();
    clearExternalRateTest();
  };

  const showExternalRateTest = () => {
    fetchExternalNetworkDD();
    setShowExternalTestDialog(true);
  };

  const formatDateTimeForAPI = (date, time) => {
    if (!date) return "";
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear();
    return `${month}/${day}/${year} ${time || "12:00pm"}`;
  };

  const onExternalRateTestSubmit = (data) => {
    const selectedNetwork = ExternalNetworkDD?.find(
      (network) => network.id === data?.externalNetwork
    );

    const payload = {
      authName: selectedNetwork?.authName,
      authKey: selectedNetwork?.authKey,
      locationId: formFieldValueMap?.fkLocationId,
      pickup: formatDateTimeForAPI(data?.startDate, data?.startTime),
      dropoff: formatDateTimeForAPI(data?.endDate, data?.endTime),
      age: data?.age,
    };

    fetchExternalRateTest(payload);
  };

  const getFormErrorMessage4 = (name) => {
    return (
      errors4[name] && (
        <small className="p-error">{errors4[name].message}</small>
      )
    );
  };

  useEffect(() => {
    if (isRateAdminRatesCreateSuccess || isRateAdminRatesEditSuccess) {
      reset(formFieldValueMap);
      setIsEditingInline(false);
    }
  }, [isRateAdminRatesCreateSuccess, isRateAdminRatesEditSuccess, formFieldValueMap, reset]);

  useEffect(() => {
    // Only call init when not in inline view mode (standalone page)
    if (!isInlineView && initCreateRateAdminRatesScreen) {
      initCreateRateAdminRatesScreen();
    }
  }, [isInlineView]);

  const { id: routeId } = useParams();
  // Use route param id for standalone mode, or formFieldValueMap.id for inline mode
  const id = isInlineView ? formFieldValueMap?.id : routeId;
  
  const onRateSubmit = (data) => {
    let newData = data;
    newData["userId"] = localStorage.getItem("userId");
    newData["rateId"] = id;
    let stringifiedData = {
      ...newData,
    };
    if (isEdit || isView) {
      createRateAdminRateAdjustment(stringifiedData);
    }
  };
  const onRateTestSubmit = (data) => {
    let newData = data;
    newData["userId"] = localStorage.getItem("userId");
    newData["rateId"] = id;
    newData["startDate"] = formatDatesHyphan(data?.startDate);
    newData["endDate"] = formatDatesHyphan(data?.endDate);

    let stringifiedData = {
      ...newData,
    };
    if (isEdit || isView) {
      TestRateAdminRates(stringifiedData);
    }
  };
  useEffect(() => {
    if (isRateAdminRatesDetailSuccess && RateOptionsDD?.length > 0) {
      reset({
        ...formFieldValueMap,
      });
    }
  }, [isRateAdminRatesDetailSuccess, formFieldValueMap, RateOptionsDD]);
  useEffect(() => {
    if (isRateAdminRateAdjListSuccess && formFieldValueMap2) {
      const recordsArray = Object.entries(formFieldValueMap2).map(
        ([key, value]) => {
          return { key, value };
        }
      );
      setRateAdjustmentList(recordsArray);
      resetForm2({
        ...formFieldValueMap2,
      });
    }
  }, [isRateAdminRateAdjListSuccess, formFieldValueMap2]);

  const copyRateAdminAdvanceRatesRoute = () => {
    const path = generatePath(APP_URLS.RATEADMIN_RATES.COPY, {
      id,
    });
    navigate(path, { state: { returnUrl: APP_URLS.RATEADMIN_ADVANCERATE.HOME } });
  };

  const onSubmit = (data) => {
    let newData = data;
    newData["userId"] = localStorage.getItem("userId");

    let rateBaseDTO = [
      {
        fkRatePlanId: 1,
        id: null || (isEdit && data?.dailybaseId),
        miles: data?.dailybaseMiles || 0,
        rate: data?.dailybaseRate || 0,
      },
      {
        fkRatePlanId: 2,
        id: null || (isEdit && data?.weekendbaseId),
        miles: data?.weekendbaseMiles || 0,
        rate: data?.weekendbaseRate || 0,
      },
      {
        fkRatePlanId: 3,
        id: null || (isEdit && data?.weeklybaseId),
        miles: data?.weeklybaseMiles || 0,
        rate: data?.weeklybaseRate || 0,
      },
      {
        fkRatePlanId: 4,
        id: null || (isEdit && data?.monthlybaseId),
        miles: data?.monthlybaseMiles || 0,
        rate: data?.monthlybaseRate || 0,
      },
    ];

    let rateExtraDayDTOS = [
      {
        fkRatePlanId: 1,
        id: null || (isEdit && data?.dailyextraId),
        miles: data?.dailyextraMiles || 0,
        rate: data?.dailyextraRate || 0,
        status: 0,
      },
      {
        fkRatePlanId: 2,
        id: null || (isEdit && data?.weekendextraId),
        miles: data?.weekendextraMiles || 0,
        rate: data?.weekendextraRate || 0,
        status: 0,
      },
      {
        fkRatePlanId: 3,
        id: null || (isEdit && data?.weeklyextraId),
        miles: data?.weeklyextraMiles || 0,
        rate: data?.weeklyextraRate || 0,
        status: 0,
      },
      {
        fkRatePlanId: 4,
        id: null || (isEdit && data?.monthlyextraId),
        miles: data?.monthlyextraMiles || 0,
        rate: data?.monthlyextraRate || 0,
        status: 0,
      },
    ];
    // All plans share the same extra hour rate (driven by the daily entry)
    let rateExtraHourDTOS = [
      {
        fkRatePlanId: 1,
        id: null || (isEdit && data?.dailyhoursId),
        rate: data?.dailyhoursRate,
      },
      {
        fkRatePlanId: 2,
        id: null || (isEdit && data?.weekendhoursId),
        rate: data?.dailyhoursRate,
      },
      {
        fkRatePlanId: 3,
        id: null || (isEdit && data?.weeklyhoursId),
        rate: data?.dailyhoursRate,
      },
      {
        fkRatePlanId: 4,
        id: null || (isEdit && data?.monthlyhoursId),
        rate: data?.dailyhoursRate,
      },
    ];
    let rateLorAdjustmentDTOS = [
      {
        fkLorId: 1,
        id: null || (isEdit && data?.dailylor1stId),
        rate: data?.dailylor1st,
      },
      {
        fkLorId: 2,
        id: null || (isEdit && data?.dailylor2ndId),
        rate: data?.dailylor2nd,
      },
      {
        fkLorId: 3,
        id: null || (isEdit && data?.dailylor3rdId),
        rate: data?.dailylor3rd,
      },
      {
        fkLorId: 4,
        id: null || (isEdit && data?.dailylor4thId),
        rate: data?.dailylor4th,
      },
      {
        fkLorId: 5,
        id: null || (isEdit && data?.dailylor5thId),
        rate: data?.dailylor5th,
      },
      {
        fkLorId: 6,
        id: null || (isEdit && data?.dailylor6thId),
        rate: data?.dailylor6th,
      },
      {
        fkLorId: 7,
        id: null || (isEdit && data?.weekendlor1stId),
        rate: data?.weekendlor1st,
      },
      {
        fkLorId: 8,
        id: null || (isEdit && data?.weekendlor2ndId),
        rate: data?.weekendlor2nd,
      },
      {
        fkLorId: 9,
        id: null || (isEdit && data?.weekendlor3rdId),
        rate: data?.weekendlor3rd,
      },
      {
        fkLorId: 10,
        id: null || (isEdit && data?.weekendlor4thId),
        rate: data?.weekendlor4th,
      },
      {
        fkLorId: 11,
        id: null || (isEdit && data?.weekendlor5thId),
        rate: data?.weekendlor5th,
      },
      {
        fkLorId: 12,
        id: null || (isEdit && data?.weekendlor6thId),
        rate: data?.weekendlor6th,
      },

      {
        fkLorId: 13,
        id: null || (isEdit && data?.weeklylor1stId),
        rate: data?.weeklylor1st,
      },
      {
        fkLorId: 14,
        id: null || (isEdit && data?.weeklylor2ndId),
        rate: data?.weeklylor2nd,
      },
      {
        fkLorId: 15,
        id: null || (isEdit && data?.weeklylor3rdId),
        rate: data?.weeklylor3rd,
      },
      {
        fkLorId: 16,
        id: null || (isEdit && data?.weeklylor4thId),
        rate: data?.weeklylor4th,
      },
    ];

    const stringifiedData = {
      id: isEdit ? data?.id : null,
      status: 1,
      rateOption: data?.rateOption,
      extraMiles: data?.extraMiles,
      startDate: formatDatesHyphan(data?.startDate),
      endDate: formatDatesHyphan(data?.endDate),
      fkCategory: data?.fkCategory,
      fkLocationId: data?.fkLocationId,
      fkNetworkId: data?.fkNetworkId,
      fkRateGroup: data?.fkRateGroup,
      fkRateTypeId: data?.fkRateTypeId,
      userId: localStorage.getItem("userId"),
      rateBaseDTO: rateBaseDTO,
      rateExtraDayDTOS: rateExtraDayDTOS,
      rateExtraHourDTOS: rateExtraHourDTOS,
      rateLorAdjustmentDTOS: rateLorAdjustmentDTOS,
    };
    isEdit
      ? editRateAdminRates({ id: data.id, data: stringifiedData })
      : createRateAdminRates(stringifiedData);
  };
  const getToastProps = () => {
    if (isRateAdminRatesEditSuccess) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Rates Updated Successfully",
        shouldShowToast: true,
      };
    }
    if (isRateAdminRatesEditError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Error while updating Rates",
        shouldShowToast: true,
      };
    }
    if (isRateAdminRateAdjSuccess) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Rates Adjustment Saved Successfully",
        shouldShowToast: true,
      };
    }
    return {
      severity: TOAST_SEVERITY.ERROR,
      toastTitle: "Please select category from list",
      shouldShowToast: false,
    };
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const getFormErrorMessage2 = (name) => {
    return (
      errors2[name] && (
        <small className="p-error">{errors2[name].message}</small>
      )
    );
  };
  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
          </div>
          <div className="buttonarea">
            {(isEdit || isView) && (
              <>
                <Button
                  tooltip={"Rate Test"}
                  tooltipOptions={{ position: "left" }}
                  label={"Rate Test"}
                  className={`p-button black-button`}
                  style={{ borderRadius: "10px" }}
                  onClick={showRateTest}
                />

                <Button
                  tooltip={"Rate Test (External API)"}
                  tooltipOptions={{ position: "left" }}
                  label={"Rate Test (External API)"}
                  className={`p-button black-button`}
                  style={{ borderRadius: "10px" }}
                  onClick={showExternalRateTest}
                />

                <Button
                  tooltip={"Rate Adjustment"}
                  tooltipOptions={{ position: "left" }}
                  label={"Rate Adjustment"}
                  className={`p-button`}
                  style={{ borderRadius: "10px" }}
                  onClick={showRateAdjustment}
                />

                <Button
                  tooltip={isEditingInline ? "Editing Rate" : "Edit Rate"}
                  tooltipOptions={{ position: "left" }}
                  label={isEditingInline ? "Editing" : "Edit Rate"}
                  className={`p-button ${isEditingInline ? 'p-button-raised p-button-secondary' : ''}`}
                  style={{ borderRadius: "10px" }}
                  onClick={() => setIsEditingInline(!isEditingInline)}
                />
                <Button
                  tooltip={"Copy Rate"}
                  tooltipOptions={{ position: "left" }}
                  label={"Copy Rate"}
                  className={`p-button`}
                  style={{ borderRadius: "10px" }}
                  onClick={copyRateAdminAdvanceRatesRoute}
                />
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  const content = (
    <>
      <EzToast {...getToastProps()} />
      <div className={`containerbox ${classes.bg}`}>
        {renderPageHeaderSection()}
        <div className="form-demo">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <Grid container spacing={2} mt={2}>
              {basicDetail?.map((item) =>
                item.name === "rateOption" || 
                item.name === "fkRateGroup" || 
                item.name === "fkNetworkId" || 
                item.name === "fkRateTypeId" ? null : 
                item.name === "fkCategory" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={vehicleCategoryDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.type === "date" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledCalendarWithFloatingLabel
                      id={item.name}
                      name={item.name}
                      {...register(item.name)}
                      showTime={false}
                      maxDate={new Date(2090, 0, 1)}
                      dateFormat="yy/mm/dd"
                      control={control}
                      isError={errors[item.name]}
                      errorMsg={getFormErrorMessage(item.name)}
                      label={item.label}
                      rules={
                        getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE
                      }
                    />
                  </Grid>
                ) : item.name === "fkLocationId" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={locationDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ),
              )}
            </Grid>
            <Grid>
              <div className="table-responsive">
                <table className="tablerate">
                  <tr>
                    <th>Rate</th>
                    <th>Base</th>
                    <th>Extra Day</th>
                    <th>Hour</th>
                    <th colSpan={"6"}>LOR Adjustments</th>
                  </tr>
                  <tr>
                    <td>Plan</td>
                    <td>Rate</td>
                    <td>Rate</td>
                    <td>Rate</td>
                    <td>1st</td>
                    <td>2nd</td>
                    <td>3rd</td>
                    <td>4th</td>
                    <td>5th</td>
                    <td>6th</td>
                  </tr>
                  <tr>
                    {rateExtraDaily?.map((item) =>
                      item.name !== undefined ? (
                        <td>
                          <EzControlledInputWithFloatingLabel
                            name={item?.name}
                            control={control}
                            //label={item?.label}
                            disabled={!!isView || !isEditingInline}
                            type={item?.type}
                            rules={item?.rule}
                            isError={errors[item?.name]}
                            errorMsg={getFormErrorMessage(item?.name)}
                          />
                          {item.notify !== undefined ? (
                            <span className="red">{item.notify}</span>
                          ) : (
                            ""
                          )}

                          {item.name === "dailylor1st" ? (
                            <span className="red">
                              {additionbaselor(dailybaseRate, dailylor1st)}
                            </span>
                          ) : item.name === "dailylor2nd" ? (
                            <span className="red">
                              {additionbaselor(dailybaseRate, dailylor2nd)}
                            </span>
                          ) : item.name === "dailylor3rd" ? (
                            <span className="red">
                              {additionbaselor(dailybaseRate, dailylor3rd)}
                            </span>
                          ) : item.name === "dailylor4th" ? (
                            <span className="red">
                              {additionbaselor(dailybaseRate, dailylor4th)}
                            </span>
                          ) : item.name === "dailylor5th" ? (
                            <span className="red">
                              {additionbaselor(dailybaseRate, dailylor5th)}
                            </span>
                          ) : item.name === "dailylor6th" ? (
                            <span className="red">
                              {additionbaselor(dailybaseRate, dailylor6th)}
                            </span>
                          ) : (
                            ""
                          )}
                        </td>
                      ) : (
                        <td>{item.label}</td>
                      ),
                    )}
                  </tr>

                  <tr>
                    {rateExtraWeekend?.map((item) =>
                      item.name !== undefined ? (
                        <td>
                          <EzControlledInputWithFloatingLabel
                            name={item?.name}
                            control={control}
                            //label={item?.label}
                            disabled={!!isView || !isEditingInline}
                            type={item?.type}
                            rules={item?.rule}
                            isError={errors[item?.name]}
                            errorMsg={getFormErrorMessage(item?.name)}
                          />
                          {item.notify !== undefined ? (
                            <span className="red">{item.notify}</span>
                          ) : (
                            ""
                          )}

                          {item.name === "weekendlor1st" ? (
                            <span className="red">
                              {additionbaselor(weekendbaseRate, weekendlor1st)}
                            </span>
                          ) : item.name === "weekendlor2nd" ? (
                            <span className="red">
                              {additionbaselor(weekendbaseRate, weekendlor2nd)}
                            </span>
                          ) : item.name === "weekendlor3rd" ? (
                            <span className="red">
                              {additionbaselor(weekendbaseRate, weekendlor3rd)}
                            </span>
                          ) : item.name === "weekendlor4th" ? (
                            <span className="red">
                              {additionbaselor(weekendbaseRate, weekendlor4th)}
                            </span>
                          ) : item.name === "weekendlor5th" ? (
                            <span className="red">
                              {additionbaselor(weekendbaseRate, weekendlor5th)}
                            </span>
                          ) : item.name === "weekendlor6th" ? (
                            <span className="red">
                              {additionbaselor(weekendbaseRate, weekendlor6th)}
                            </span>
                          ) : (
                            ""
                          )}
                        </td>
                      ) : (
                        <td>{item.label}</td>
                      ),
                    )}
                  </tr>
                  <tr>
                    {rateExtraWeekly?.map((item) =>
                      item.name !== undefined ? (
                        <td>
                          <EzControlledInputWithFloatingLabel
                            name={item?.name}
                            control={control}
                            //label={item?.label}
                            disabled={!!isView || !isEditingInline}
                            type={item?.type}
                            rules={item?.rule}
                            isError={errors[item?.name]}
                            errorMsg={getFormErrorMessage(item?.name)}
                          />

                          {item.notify !== undefined ? (
                            <span className="red">{item.notify}</span>
                          ) : (
                            ""
                          )}

                          {item.name === "weeklylor1st" ? (
                            <span className="red">
                              {additionbaselor(weeklybaseRate, weeklylor1st)}
                            </span>
                          ) : item.name === "weeklylor2nd" ? (
                            <span className="red">
                              {additionbaselor(weeklybaseRate, weeklylor2nd)}
                            </span>
                          ) : item.name === "weeklylor3rd" ? (
                            <span className="red">
                              {additionbaselor(weeklybaseRate, weeklylor3rd)}
                            </span>
                          ) : item.name === "weeklylor4th" ? (
                            <span className="red">
                              {additionbaselor(weeklybaseRate, weeklylor4th)}
                            </span>
                          ) : (
                            ""
                          )}
                        </td>
                      ) : (
                        <td>{item.label}</td>
                      ),
                    )}
                  </tr>
                  <tr>
                    {rateExtraMonthly?.map((item) =>
                      item.name !== undefined ? (
                        <td>
                          <EzControlledInputWithFloatingLabel
                            name={item?.name}
                            control={control}
                            //label={item?.label}
                            disabled={!!isView || !isEditingInline}
                            type={item?.type}
                            rules={item?.rule}
                            isError={errors[item?.name]}
                            errorMsg={getFormErrorMessage(item?.name)}
                          />
                        </td>
                      ) : (
                        <td>{item.label}</td>
                      ),
                    )}
                  </tr>
                  <tr>
                    <td colSpan={"6"}>Extra miles rate for all rate plans: </td>
                    <td colSpan={"6"}>
                      <EzControlledInputWithFloatingLabel
                        name={"extraMiles"}
                        control={control}
                        //label={item?.label}
                        disabled={!!isView || !isEditingInline}
                        type={"text"}
                        rules={
                          getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE
                        }
                        isError={errors["extraMiles"]}
                        errorMsg={getFormErrorMessage("extraMiles")}
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </Grid>

            <div className={"make-flex mt-3 mr-2"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                }}
              >
                {!isView && isEditingInline && (
                  <React.Fragment>
                    <div
                      style={{
                        margin: "15px 0px 15px 10px",
                        minWidth: "100px",
                      }}
                    >
                      <Button
                        type="button"
                        label={"Cancel"}
                        className="mt-2 p-button-raised p-button-secondary"
                        onClick={() => {
                          setIsEditingInline(false);
                          reset(formFieldValueMap);
                        }}
                      />
                    </div>
                    <div
                      style={{
                        margin: "15px 0px 15px 10px",
                        minWidth: "100px",
                      }}
                    >
                      <Button
                        type="submit"
                        label={"Update"}
                        className="mt-2 p-button-raised"
                      />
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
            {(isEdit || isView) && (
              <Grid className="modsection" container spacing={2}>
                {editMode?.map((item) => (
                  <Grid item xs={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      disabled={item?.disabled}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </form>
        </div>
      </div>
      <div>
        {rateAdjustmentlist?.length > 0 && (
          <Box id="printable">
            <Typography variant="h6" mt={"20px"}>
              Rate Adjustments{" "}
            </Typography>
            <DataTable value={rateAdjustmentlist}>
              <Column field="locationTitle" header="Location"></Column>
              <Column field="categoryTitle" header="Category"></Column>
              <Column field="networkTitle" header="Network"></Column>
              <Column field="startDate" header="Start Date"></Column>
              <Column field="endDate" header="End Date"></Column>
              <Column field="lor" header="LOR"></Column>
              <Column field="adjust" header="Adjust"></Column>
              <Column field="created By" header="Created By"></Column>
            </DataTable>
          </Box>
        )}
      </div>

      {showDialog && (
        <EzDialog
          onHide={onDialogHide}
          maximizable={false}
          width={window.innerWidth <= 600 ? "100vw" : "50vw"}
          height={"275px"}
          header={"Increase Rate by %age"}
        >
          <form onSubmit={handleSubmit2(onRateSubmit)} className="p-fluid">
            <Grid container spacing={2} paddingTop={"20px"}>
              {rateAdjustment?.map((item) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                  <EzControlledInputWithFloatingLabel
                    name={item?.name}
                    control={control2}
                    label={item?.label}
                    type={item?.type}
                    rules={item?.rule}
                    isError={errors2[item?.name]}
                    errorMsg={getFormErrorMessage2(item?.name)}
                  />
                </Grid>
              ))}
            </Grid>
            <div className={"make-flex mt-3 mr-2"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                }}
              >
                <React.Fragment>
                  <div
                    style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}
                  >
                    <Button
                      type="button"
                      label={"Cancel"}
                      className="mt-2 p-button-raised"
                      onClick={onDialogHide}
                    />
                  </div>
                  <div
                    style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}
                  >
                    <Button
                      type="submit"
                      label={"Save"}
                      className="mt-2 p-button-raised"
                    />
                  </div>
                </React.Fragment>
              </div>
            </div>
          </form>
        </EzDialog>
      )}

      {showTestDialog && (
        <EzDialog
          onHide={onDialogTestHide}
          maximizable={false}
          width={window.innerWidth <= 600 ? "100vw" : "50vw"}
          height={"275px"}
          header={"Rate Test"}
        >
          <form onSubmit={handleSubmit3(onRateTestSubmit)} className="p-fluid">
            <Grid container spacing={2} paddingTop={"20px"}>
              {rateTest?.map((item) =>
                item.type === "date" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledCalendarWithFloatingLabel
                      id={item.name}
                      name={item.name}
                      {...register(item.name)}
                      showTime={false}
                      maxDate={new Date(2090, 0, 1)}
                      dateFormat="yy/mm/dd"
                      control={control3}
                      isError={errors3[item.name]}
                      errorMsg={getFormErrorMessage(item.name)}
                      label={item.label}
                      rules={
                        getFormBaseValidationRule().DEFAULT.VALIDATION_RULE
                      }
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control3}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={hourslist}
                      isError={errors3[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ),
              )}
            </Grid>
            {RateTest?.totalRate !== undefined && (
              <Grid
                container
                spacing={2}
                paddingTop={"20px"}
                className="testcont"
              >
                <Typography className="p">
                  Total Rate - ${RateTest?.totalRate}{" "}
                  <span onClick={() => setBreakdown(!breakdown)}>
                    View Breakdown
                  </span>
                </Typography>
                {breakdown === true && (
                  <Table className="ratetest">
                    <TableBody>
                      <TableRow>
                        <TableCell>Before Taxes</TableCell>
                        <TableCell>
                          $ {RateTest?.beforeTax}
                          <br />
                          {RateTest?.beforeTaxDays}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Fees</TableCell>
                        <TableCell>${RateTest?.fees}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Underage driver fee</TableCell>
                        <TableCell>${RateTest?.underageDriverFee}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Airport Facility Charge</TableCell>
                        <TableCell>
                          ${RateTest?.airportFacilityCharge}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Concession Fee</TableCell>
                        <TableCell>${RateTest?.concessionFee}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>After hour fees</TableCell>
                        <TableCell>${RateTest?.afterHourFees}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Estimated Taxes</TableCell>
                        <TableCell>${RateTest?.estimatedTaxes}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Total Amount</TableCell>
                        <TableCell>${RateTest?.totalAmount}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                )}
                <Typography color={"red"} fontSize={"12px"}>
                  Please note that this rate simulation does not check for
                  blackouts, rate mirrors, underage fee and category existing
                  for the location.
                </Typography>
              </Grid>
            )}
            <div className={"make-flex mt-3 mr-2"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                }}
              >
                <React.Fragment>
                  <div
                    style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}
                  >
                    <Button
                      type="button"
                      label={"Cancel"}
                      className="mt-2 p-button-raised"
                      onClick={onDialogTestHide}
                    />
                  </div>
                  <div
                    style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}
                  >
                    <Button
                      type="submit"
                      label={"Check Rates"}
                      className="mt-2 p-button-raised"
                    />
                  </div>
                </React.Fragment>
              </div>
            </div>
          </form>
        </EzDialog>
      )}

      {showExternalTestDialog && (
        <EzDialog
          onHide={onExternalDialogHide}
          maximizable={false}
          width={window.innerWidth <= 600 ? "100vw" : "60vw"}
          height={"auto"}
          header={"Rate Test (External API)"}
        >
          <form onSubmit={handleSubmit4(onExternalRateTestSubmit)} className="p-fluid">
            <Grid container spacing={2} paddingTop={"20px"}>
              {/* External Network Dropdown */}
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <EzControlledDropDowntWithFloatingLabel
                  name="externalNetwork"
                  control={control4}
                  rules={{ required: "External Network is required" }}
                  optionLabel={"title"}
                  optionValue={"id"}
                  options={ExternalNetworkDD || []}
                  isError={errors4["externalNetwork"]}
                  errorMsg={getFormErrorMessage4("externalNetwork")}
                  label="External Network"
                  labelClassName={"ml-2"}
                />
              </Grid>

              {/* Start Date */}
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <EzControlledCalendarWithFloatingLabel
                  id="startDate"
                  name="startDate"
                  showTime={false}
                  minDate={tomorrow}
                  maxDate={new Date(2090, 0, 1)}
                  dateFormat="yy/mm/dd"
                  control={control4}
                  isError={errors4["startDate"]}
                  errorMsg={getFormErrorMessage4("startDate")}
                  label="Start Date"
                  rules={{ required: "Start Date is required" }}
                />
              </Grid>

              {/* Start Time */}
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <EzControlledDropDowntWithFloatingLabel
                  name="startTime"
                  control={control4}
                  rules={{ required: "Start Time is required" }}
                  optionLabel={"name"}
                  optionValue={"id"}
                  options={hourslist}
                  isError={errors4["startTime"]}
                  errorMsg={getFormErrorMessage4("startTime")}
                  label="Start Time"
                  labelClassName={"ml-2"}
                />
              </Grid>

              {/* End Date */}
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <EzControlledCalendarWithFloatingLabel
                  id="endDate"
                  name="endDate"
                  showTime={false}
                  minDate={tomorrow}
                  maxDate={new Date(2090, 0, 1)}
                  dateFormat="yy/mm/dd"
                  control={control4}
                  isError={errors4["endDate"]}
                  errorMsg={getFormErrorMessage4("endDate")}
                  label="End Date"
                  rules={{ required: "End Date is required" }}
                />
              </Grid>

              {/* End Time */}
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <EzControlledDropDowntWithFloatingLabel
                  name="endTime"
                  control={control4}
                  rules={{ required: "End Time is required" }}
                  optionLabel={"name"}
                  optionValue={"id"}
                  options={hourslist}
                  isError={errors4["endTime"]}
                  errorMsg={getFormErrorMessage4("endTime")}
                  label="End Time"
                  labelClassName={"ml-2"}
                />
              </Grid>

              {/* Age Dropdown */}
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <EzControlledDropDowntWithFloatingLabel
                  name="age"
                  control={control4}
                  rules={{ required: "Age is required" }}
                  optionLabel={"name"}
                  optionValue={"id"}
                  options={ageOptions}
                  isError={errors4["age"]}
                  errorMsg={getFormErrorMessage4("age")}
                  label="Age"
                  labelClassName={"ml-2"}
                />
              </Grid>
            </Grid>

            {/* Buttons - Cancel and Check Rates */}
            <div className={"make-flex mt-3 mr-2"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                }}
              >
                <React.Fragment>
                  <div
                    style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}
                  >
                    <Button
                      type="button"
                      label={"Cancel"}
                      className="mt-2 p-button-raised"
                      onClick={onExternalDialogHide}
                    />
                  </div>
                  <div
                    style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}
                  >
                    <Button
                      type="submit"
                      label={"Check Rates"}
                      className="mt-2 p-button-raised"
                    />
                  </div>
                </React.Fragment>
              </div>
            </div>

            {/* Display External Rate Test Results */}
            {isExternalRateTestSuccess && ExternalRateTest && (
              <Grid
                container
                spacing={2}
                paddingTop={"20px"}
                className="testcont"
              >
                {/* Filter records by vehicle category ID */}
                {(() => {
                  const categoryId = formFieldValueMap?.fkCategory;
                  const filteredRecords = ExternalRateTest?.records?.filter(
                    (vehicle) => String(vehicle.vehicleDetail?.id) === String(categoryId)
                  ) || [];
                  const filteredInclusive = ExternalRateTest?.inclusive?.filter(
                    (vehicle) => String(vehicle.vehicleDetail?.id) === String(categoryId)
                  ) || [];
                  
                  // Get selected network title
                  const selectedNetworkData = ExternalNetworkDD?.find(
                    (network) => network.id === watch4("externalNetwork")
                  );
                  const networkTitle = selectedNetworkData?.title || 'External Network';
                  
                  // Get class code from first filtered record
                  const classCode = filteredRecords[0]?.vehicleDetail?.classCode || filteredInclusive[0]?.vehicleDetail?.classCode || 'N/A';
                  
                  return (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="h6" className="p" style={{ marginBottom: '15px', borderBottom: '2px solid #1976d2', paddingBottom: '10px' }}>
                          External Rate Test Results at <span style={{ color: '#1976d2' }}>{networkTitle}</span> for <span style={{ color: '#1976d2' }}>{classCode}</span>
                        </Typography>
                      </Grid>
                      
                      {/* Vehicle Rates Table Display */}
                      {filteredRecords.length > 0 && (
                        <Grid item xs={12}>
                          <Table size="small" style={{ backgroundColor: '#fff', border: '1px solid #e0e0e0' }}>
                            <TableBody>
                              {/* Header Row */}
                              <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell style={{ fontWeight: '600', width: '200px' }}>Vehicle</TableCell>
                                <TableCell style={{ fontWeight: '600' }}>Rate Details</TableCell>
                              </TableRow>
                              
                              {filteredRecords.map((vehicle, index) => {
                                // Calculate estimated taxes (net_rate - daily_rate * days)
                                const baseAmount = parseFloat(vehicle.daily_rate || 0) * parseInt(vehicle.days || 1);
                                const totalAmount = parseFloat(vehicle.net_rate || 0);
                                const estimatedTaxes = (totalAmount - baseAmount).toFixed(2);
                                
                                return (
                                  <TableRow key={vehicle.rate_quote_id || index}>
                                    {/* Vehicle Info Column */}
                                    <TableCell style={{ verticalAlign: 'middle', borderRight: '1px solid #e0e0e0' }}>
                                      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                        {/* Vehicle Image */}
                                        {vehicle.vehicleDetail?.imageURL && (
                                          <div style={{ 
                                            width: '100px', 
                                            height: '70px', 
                                            flexShrink: 0,
                                            borderRadius: '3px',
                                            overflow: 'hidden',
                                            backgroundColor: '#f5f5f5'
                                          }}>
                                            <img 
                                              src={vehicle.vehicleDetail.imageURL} 
                                              alt={vehicle.vehicleDetail?.name || 'Vehicle'}
                                              style={{ 
                                                width: '100%', 
                                                height: '100%', 
                                                objectFit: 'cover'
                                              }}
                                            />
                                          </div>
                                        )}
                                        {/* Vehicle Details */}
                                        <div>
                                          <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '4px' }}>
                                            {vehicle.vehicleDetail?.name || 'N/A'}
                                          </div>
                                          <span style={{ 
                                            backgroundColor: '#1976d2', 
                                            color: '#fff', 
                                            padding: '2px 6px', 
                                            borderRadius: '3px',
                                            fontSize: '10px',
                                            fontWeight: '500'
                                          }}>
                                            {vehicle.vehicleDetail?.classCode || 'N/A'}
                                          </span>
                                          {vehicle.vehicleDetail?.short_description && (
                                            <div style={{ fontSize: '11px', color: '#666', marginTop: '6px' }}>
                                              {vehicle.vehicleDetail.short_description}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </TableCell>
                                    
                                    {/* Rate Details Column */}
                                    <TableCell style={{ verticalAlign: 'top' }}>
                                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                                        {/* Left side - Pay Later */}
                                        <div style={{ padding: '8px', backgroundColor: '#e3f2fd', borderRadius: '4px' }}>
                                          <div style={{ fontWeight: '600', fontSize: '12px', color: '#1976d2', marginBottom: '6px' }}>
                                            PAY LATER
                                          </div>
                                          <div style={{ fontSize: '11px', display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                                            <span>Daily Rate:</span>
                                            <span>${vehicle.daily_rate || '0.00'}</span>
                                          </div>
                                          <div style={{ fontSize: '11px', display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                                            <span>Duration:</span>
                                            <span>
                                              {vehicle.days > 0 ? `${vehicle.days} day(s)` : ''}
                                              {vehicle.weeks > 0 ? ` ${vehicle.weeks} wk` : ''}
                                              {vehicle.months > 0 ? ` ${vehicle.months} mo` : ''}
                                              {vehicle.extra_hours > 0 ? ` +${vehicle.extra_hours}hr` : ''}
                                            </span>
                                          </div>
                                          <div style={{ fontSize: '11px', display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                                            <span>Base Amount:</span>
                                            <span>${baseAmount.toFixed(2)}</span>
                                          </div>
                                          <div style={{ fontSize: '11px', display: 'flex', justifyContent: 'space-between', marginBottom: '3px', color: '#666' }}>
                                            <span>Est. Taxes & Fees:</span>
                                            <span>${estimatedTaxes}</span>
                                          </div>
                                          <div style={{ fontSize: '13px', display: 'flex', justifyContent: 'space-between', fontWeight: '700', color: '#1976d2', borderTop: '1px solid #90caf9', paddingTop: '4px', marginTop: '4px' }}>
                                            <span>Total:</span>
                                            <span>${vehicle.net_rate || '0.00'} {vehicle.currency_code || 'CAD'}</span>
                                          </div>
                                        </div>
                                        
                                        {/* Right side - Pay Now */}
                                        {vehicle.payNowRate && (
                                          <div style={{ padding: '8px', backgroundColor: '#e8f5e9', borderRadius: '4px' }}>
                                            <div style={{ fontWeight: '600', fontSize: '12px', color: '#2e7d32', marginBottom: '6px' }}>
                                              PAY NOW (Save ${(parseFloat(vehicle.net_rate) - parseFloat(vehicle.payNowRate.net_rate)).toFixed(2)})
                                            </div>
                                            <div style={{ fontSize: '11px', display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                                              <span>Daily Rate:</span>
                                              <span>${vehicle.payNowRate.daily_rate || '0.00'}</span>
                                            </div>
                                            <div style={{ fontSize: '11px', display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                                              <span>Duration:</span>
                                              <span>
                                                {vehicle.days > 0 ? `${vehicle.days} day(s)` : ''}
                                                {vehicle.weeks > 0 ? ` ${vehicle.weeks} wk` : ''}
                                                {vehicle.months > 0 ? ` ${vehicle.months} mo` : ''}
                                              </span>
                                            </div>
                                            {(() => {
                                              const payNowBase = parseFloat(vehicle.payNowRate.daily_rate || 0) * parseInt(vehicle.days || 1);
                                              const payNowTotal = parseFloat(vehicle.payNowRate.net_rate || 0);
                                              const payNowTaxes = (payNowTotal - payNowBase).toFixed(2);
                                              return (
                                                <>
                                                  <div style={{ fontSize: '11px', display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                                                    <span>Base Amount:</span>
                                                    <span>${payNowBase.toFixed(2)}</span>
                                                  </div>
                                                  <div style={{ fontSize: '11px', display: 'flex', justifyContent: 'space-between', marginBottom: '3px', color: '#666' }}>
                                                    <span>Est. Taxes & Fees:</span>
                                                    <span>${payNowTaxes}</span>
                                                  </div>
                                                </>
                                              );
                                            })()}
                                            <div style={{ fontSize: '13px', display: 'flex', justifyContent: 'space-between', fontWeight: '700', color: '#2e7d32', borderTop: '1px solid #a5d6a7', paddingTop: '4px', marginTop: '4px' }}>
                                              <span>Total:</span>
                                              <span>${vehicle.payNowRate.net_rate || '0.00'} {vehicle.currency_code || 'CAD'}</span>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </Grid>
                      )}
                
                {/* Inclusive Rates Section */}
                {filteredInclusive.length > 0 && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" style={{ 
                      marginTop: '20px', 
                      marginBottom: '10px', 
                      fontWeight: '600',
                      color: '#1976d2',
                      borderBottom: '1px solid #e0e0e0',
                      paddingBottom: '8px'
                    }}>
                      Inclusive Rates ({filteredInclusive.length} vehicle(s))
                    </Typography>
                    <Table size="small" style={{ backgroundColor: '#f1f8e9', border: '1px solid #c8e6c9' }}>
                      <TableBody>
                        <TableRow style={{ backgroundColor: '#c8e6c9' }}>
                          <TableCell style={{ fontWeight: '600', width: '150px' }}>Vehicle</TableCell>
                          <TableCell style={{ fontWeight: '600' }}>Daily Rate</TableCell>
                          <TableCell style={{ fontWeight: '600' }}>Duration</TableCell>
                          <TableCell style={{ fontWeight: '600' }}>Est. Taxes</TableCell>
                          <TableCell style={{ fontWeight: '600' }}>Total</TableCell>
                        </TableRow>
                        {filteredInclusive.map((vehicle, index) => {
                          const baseAmt = parseFloat(vehicle.daily_rate || 0) * parseInt(vehicle.days || 1);
                          const totalAmt = parseFloat(vehicle.net_rate || 0);
                          const taxes = (totalAmt - baseAmt).toFixed(2);
                          return (
                            <TableRow key={vehicle.rate_quote_id || index}>
                              <TableCell>
                                <div style={{ fontWeight: '600', fontSize: '12px' }}>{vehicle.vehicleDetail?.name || 'N/A'}</div>
                                <div style={{ fontSize: '10px', color: '#666' }}>{vehicle.vehicleDetail?.classCode || 'N/A'}</div>
                              </TableCell>
                              <TableCell>${vehicle.daily_rate || '0.00'}</TableCell>
                              <TableCell>
                                {vehicle.days > 0 ? `${vehicle.days} day(s)` : ''}
                                {vehicle.weeks > 0 ? ` ${vehicle.weeks} wk` : ''}
                              </TableCell>
                              <TableCell>${taxes}</TableCell>
                              <TableCell style={{ fontWeight: '600', color: '#2e7d32' }}>
                                ${vehicle.net_rate || '0.00'} {vehicle.currency_code || 'CAD'}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </Grid>
                )}
                
                {/* No Results Message */}
                {filteredRecords.length === 0 && (
                  <Grid item xs={12}>
                    <div style={{ 
                      textAlign: 'center', 
                      padding: '40px', 
                      color: '#999',
                      backgroundColor: '#f5f5f5',
                      borderRadius: '8px'
                    }}>
                      <Typography>No vehicle rates found for category ID: {categoryId}.</Typography>
                      {ExternalRateTest?.records?.length > 0 && (
                        <Typography style={{ fontSize: '12px', marginTop: '8px' }}>
                          (API returned {ExternalRateTest.records.length} vehicles, but none match the current rate's category)
                        </Typography>
                      )}
                    </div>
                  </Grid>
                )}
              </>
            );
          })()}
              </Grid>
            )}

            {isExternalRateTestError && (
              <Grid container spacing={2} paddingTop={"20px"}>
                <Grid item xs={12}>
                  <Typography color="error">
                    Error fetching external rates. Please try again.
                  </Typography>
                </Grid>
              </Grid>
            )}
          </form>
        </EzDialog>
      )}
    </>
  );

  if (isInlineView) {
    return (
      <Box sx={{ backgroundColor: '#fff' }}>
        {content}
      </Box>
    );
  }

  return (
    <Container maxWidth="lg">
      {content}
    </Container>
  );
};

export default ViewInlineRateAdminRates;
